export const getOriginalComment = comment => {
  if (comment?.includes('(Original)')) {
    return comment.split('(Original)')[1].trim()
  }

  return comment
}
